export default __webpack_public_path__ + "static/media/logo.cd8aefe4.png";